import { exitFormalitie } from "./data/bgData";
import BackgroundVerification from "./pages/backgroundVerification";

export const recruitConstant = {
    jobOpeningID: "Job Opening ID",
    postingTitle: "Posting Title",
    assignedRecruiter: "Assigned Recruiter",
    targetDate: "Target Date",
    interviewId: "ID",
    city: "City",
    enterCity: "Enter City",
    status: "Status",
    department: "Department",
    hiringManager: "Hiring Manager",
    actions: "Action",
    applicationName: "Application Name",
    currentLocation: "Current Location",
    applicationId: "ID",
    departmentID: "ID",
    jobOpenings: "Job Openings",
    editCandidates: "Edit Candidate",
    editReferral: "Edit Referral",
    date: "Date",
    rating: "Rating",
    feedback: "Feedback",
    viewFeedback: "View Feedback",
    submitFeedback: "Submit Feedback",
    candidateStage: "Stage",
    candidateName: "Candidate Name",
    candidate: "Candidate",
    modifyTime: "Modify Time",
    modifiedAt: "Modified At",
    datePosted: "Date Posted",
    createdAt: "Created At",
    interviewers: "Interviewers",
    interviewDate: "Interview Date",
    applicantName: "Applicant Name",
    source: "Source",
    jobID: "ID",
    candidateOwner: "Owner",
    experience: "Experience",
    skills: "Skills",
    resume: "Resume",
    application: "Applications",
    createApplication: "Create Application",
    jobOpeningId: "jobOpeningId",
    jobApplication: "Job Application",
    postingTitleAccessor: "postingTitle",
    assignedRecruiterAccessor: "assignedRecruiter",
    targetDateAccessor: "targetDate",
    createJobOpening: "Create job opening",
    jobProfile: "Job Profile",
    advanceSearch: "Advance Search",
    referrals: "referrals",
    statusAccessor: "status",
    state: "State",
    enterState: "Enter State",
    departmentAccessor: "department",
    hiringManagerAccessor: "hiringManager",
    action: "Action",
    candidates: "Candidates",
    interviewName: "Interview Name",
    from: "From",
    to: "To",
    candidatesName: "Candidate Name",
    jobtitle: "Current Job Title",
    referredBy: "Referred By",
    experience: "Experience",
    currentEmployer: "Current Employer",
    interviewOwner: "Interview Owner",
    createCandidates: "Create Candidate",
    createReferrals: "Create Referral",
    interviews: "Interviews",
    departments: "Departments",
    campaigns: "Campaigns",
    campgain: "Campgain",
    offers: "Offers",
    offerLetter: "Offer Letter",
    campaignOwner: "Campaign Owner",
    createCampaign: "Create Campaign",
    type: "Type",
    campaignName: "Campaign Name",
    startDate: "Start Date",
    endDate: "End Date",
    expectedRevenue: "Expected Revenue",
    budgetCost: "Budget Cost",
    actualCost: "Actual Cost",
    expectedResponse: "Expected Response",
    numberSent: "Number Sent",
    deleteMsg: "Deleted successfully",
    next: "Next",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    update: "Update",
    description: "Description",
    enterDescription: "Enter description...",
    typeData: ["Conference", "Webinar", "Public relations"],
    offer: "Offer",
    job: "Job",
    jobApplicant: "Job Applicant",
    addedBy: "Added By",
    offerExpireOn: "Offer Expire On",
    expectedJoiningDate: "Expected Joining Date",
    errorMsg: "Something went wrong",
    namePlaceHolderText: "Enter Name",
    name: "Name",
    emailPlaceHolderText: "Enter Email",
    email: "Email",
    phone: "Phone",
    phonePlaceHolderText: "Enter Phone",
    cityPlaceHolderText: "Enter City",
    statePlaceHolderText: "Enter State",
    location: "Location",
    enterLocation: "Enter Location",
    totalExperience: "Total Experience",
    currentLocationLabel: "Current Location",
    noticePeriod: "Notice Period",
    applicationSource: "Application Source",
    selectTotalExp: "Select Total Experience",
    selectCurrentLocation: "Select Current Location",
    enterNoticePerios: "Enter Notice Period",
    selectStatus: "Select Status",
    selectApplicationSource: "Select Application Source",
    CoverLetter: "Cover Letter",
    attachment: "Attachment",
    resume: "Resume",
    panel: "Panel",
    panels: "Panels",
    panelName: "Panel Name",
    enterPanelName: "Enter Panel Name",
    skills: "Skills",
    availability: "Availability",
    totalExprience: "Total Experience",
    noSkillsAdded: "No skills added",
    searchSkill: "Search or add a skill",
    maximumSkills: "Maximum 15 Skills",
    add: "Add",
    createPanel: "Create Panel",
    firstName: "First Name",
    lastName: "Last Name",
    submitPanel: "Submit",
    editSkills: "Edit Skills",
    showLess: "Show Less",
    showMore: "Show More",
    enterPanelName: "Enter panel name",
    panelFullName: "panelName",
    createJobOpenings: "Job Openings",
    createApplications: "Applications",
    createCandidate: "Candidates",
    createInterView: "Interview",
    createReferral: "Referral",
    createDepartment: "Department",
    createCampaigns: "Campaign",
    bgVerification: "BG Verification",
    BackgroundVerification: "Background Verification",
    createBgVerification: "Create BG Verification",
    empId: "Emp ID",
    empName: "Emp Name",
    doj: "DOJ",
    createAt: "Create At",
    sharedAt: "Shared At",
    sharedTo: "Shared To",
    link: "Link",
    employeeID: "Employee ID",
    enterEmployeeID: "Enter Employee ID",
    companyName: "Company Name",
    enterCompanyName: "Enter company Name",
    location: "Location",
    lastDesignation: "Last Designation",
    enterLastDesignation: "Enter Last Designation",
    dateOfJoining: "Date of Joining",
    enterDepartment: "Enter Department",
    remunerationCTC: "Remuneration/CTC",
    enterremunerationCTC: "Enter Remuneration CTC",
    reasonsForLeaving: "Reasons For Leaving",
    enterReasonsForLeaving: "Enetr Resons For leaving",
    rolesAndResponsibility: "Roles And Responsibility",
    natureOfEmployment: "Nature Of Employment",
    exitFormalitiesCompleted: "Exit formalities completed",
    eligibleToReHire: "Eligible To Re-Hire",
    verifierName: "Verifier Name",
    verifierDesignation: "Verifier Designation",
    enterVerifierName: "Enter Verifier Name",
    enterVerifierDesignation: "Enter Verifier Designation ",
    verifierDetails: "Verifier Phone Number",
    enterVerifierDetails: "Enter Phone Number",
    permanent: "Permanent",
    anyPerformanceIntegrity: "Any Performance Integrity, or Disciplinary Issues",
    yes: "Yes",
    no: "No",
    enterReason: "Enter Reason",
    pleaseConfirmIf: "Please confirm if it is pending from company end or candidate end.",
    exitFormalitieText: "This is to confirm that all your exit formalities.",
    pleaseElaborate: " Please elaborate",
    pleaseSelect: "Please Select",
    createJobOpening: "Create Job Opening",
    jobOpening: "Job opening",
    postingTitle: "Posting Title",
    enterPostingTitle: "Enter Posting Title",
    departmentName: "Name",
    enterDepartmentName: "Enter department name",
    title: "Title",
    hiringManager: "Hiring Manager",
    assignedRecruiter: "Assigned Recruiter",
    numberOfPosition: "Number of Positions",
    enterNumber: "Enter Number",
    dateOpened: "Date Opened",
    recruiter: "Recruiter",
    jobOpeningStatus: "Job Opening Status",
    createdBy: "Created By",
    jobType: "Job Type",
    industry: "Industry",
    workExp: "Work Experience",
    salary: "Salary",
    requiredSkills: "Required Skills",
    totalExperienceRange: "Total Experience Range",
    selectTotalExpRange: "Select Total Experience Range",
    interviewAvailability: "Interview Availability",
    selectInterviewAvailability: "Select Interview Availability",
    enterReferral: "Enter Referral",
    enterFirstName: "Enter First Name",
    enterLirstName: "Enter Last Name",
    enterEmailId: "Enter Email ID",
    enterPhoneNumber: "Enter Phone Number",
    enterCurrentRole: "Enter Current Role",
    enterEmployer: "Enter Employer",
    delete: "Delete",
    statusUpdated: "Status updated successfully",
    someThingWentWrong: "Something went wrong",
    completed: "Completed",
    phoneNumber: "Phone Number",
    toDo: "To Do",
    onHold: "On Hold",
    inProgress: "In Progress",
    pending: "Pending",
    referAcandidate: "Refer a candidate",
    more: "more",
    deletedSuccessfully: "Deleted Successfully",
    fullName: "Full Name",
    enterFullName: "Enter Full Name",
    owner: "Owner",
    ownerAndrecruiter: "Owner/Recruiter",
    highestQualification: "Highest Qualification",
    selectSource: "Select Source",
    selectOwner: "Select Owner",
    selectHighestQualification: "Select Highest Qualification",
    selectTotalExperience: "Select Total Experience",
    enterCurrentEmployer: "Enter Current Employer",
    enterTotalExperience: "Enter Total Experience",
    fileSizeExceed2MB: "File size should not exceed 2MB",
    jobApplied: "Job Applied",
    referral: "Referral",
    compatibilityScore: "compatibility Score", // Compatibility score feature
    loadingJobDetails: "Loading job details...",
    details: "Details",
    jobDescription: "Job Description",
    jobOpeningInformation: "Job Opening Information",
    addressInfo: "Address Information",
    stateProvince: "State/Province",
    country: "Country",
    zinPostalCode: "Zip/Postal Code",
    noJobDescriptionAvailable: "No job description available",
    reasonPlaceholder: "Enter reason",
    reason: 'Reason',
    noBenefitsInfo: "No benefits information available",
    selectJobToSeeDetails: "Select a job profile to see its details.",
    interviewSlot: "Time Slot",
    roundDetails: "Round Details",
    jobOpeningDeleteMsg: 'The job opening related to this application has already been deleted.',
    selectApplication: "Select Application ",
    candidateName: "Candidate Name",
    candidatePlaceholder: "Enter Candidate Name",
    asterisk: "*",
    loading: 'Loading...',
    selectApplicationPlaceholder: "Select Application",
    emailSubject: "Email Subject ",
    emailSubjectPlaceholder: "Enter Email Subject",
    grossSalary: "Gross salary ",
    ctcSalary: "CTC salary ",
    currency: "Currency ",
    currencyPlaceholder: "₹ INR",
    Frequency: "Frequency ",
    pfRequired: "Check if PF is required",
    lastWorkingDate: "Last Working Date",
    editOfferLetter: 'Edit Offer Letter',
    addOfferLetter: 'Create Offer Letter',
    offerLetter: "Offer Letters",
    CompanyPolicies: "Company Policies",
    createCompanyPolicy: 'Create Policy',
    editCompanyPolicy: 'Edit Policy',
    createCompanySubPolicy: 'Create Sub-Policy',
    create: 'Create',
    policyName: 'Name',
    noSubPolicyFound: "No sub policies found",
    noPolicyFound: "No policies found",
    description: 'Description',
    content: "Content",
    edit: 'Update',
    download: "Download",
    close: "Close",
    view: "View",
    submit: "Submit",
}

export const rejectedStatuses = {
    rejected: "Rejected",
    r1_rejected: "R1 Rejected",
    r2_rejected: "R2 Rejected",
    r3_rejected: "R3 Rejected",
}

export const selectedStatuses = {
    selected: "Selected"
}




